import React from 'react'
import domecileLogo from '/app/assets/images/domecile_pin.png'

export default function RequestSubmissionSection({ onClose, onRequest }) {
  return (
    <div className="request-submission dome-d-flex dome-flex-column dome-gap24 dome-justify-center dome-full-width">
      <div className="dome-relative dome-d-flex dome-flex-column dome-gap24 dome-justify-center">
        <span className="dome-h2 dome-color-dark-green">request received</span>
        <div className="dome-d-flex dome-flex-column dome-gap12">
          <span className="dome-p1 dome-color-dark-green">next up...</span>
          <div className="dome-d-flex dome-flex-column">
            <span className="dome-p2 dome-color-dark-grey">1. You’ll receive email confirmation of your request.</span>
            <span className="dome-p2 dome-color-dark-grey">2. Price + payment instructions will follow by email.</span>
          </div>
        </div>

        <div className="dome-d-flex dome-justify-between">
          <button type="button" onClick={onClose} className="dome-btn dome-btn-base dome-btn-grey-stroke">
            close
          </button>
          <button
            type="button"
            onClick={onRequest}
            className="dome-btn dome-btn-link dome-btn-link-aqua dome-btn-link-chevron-right"
          >
            request another
          </button>
        </div>
        <img src={domecileLogo} alt="Domecile" className="request-submission-logo" width={16} height={23} />
      </div>
    </div>
  )
}
